import { NotFound as BaseNotFound } from 'components/shared';

import { useFormsListSearchParams } from './hooks';
import { useFormsListContext } from './context';

export const NotFound = () => {
  const { filtersParamsActive, clearFiltersParams } =
    useFormsListSearchParams();
  const { setNewFormWizardOpen } = useFormsListContext();

  const props = filtersParamsActive
    ? {
        header: 'forms:listView.notFound.header',
        buttonText: 'forms:listView.notFound.buttonText',
        onActionButtonClick: clearFiltersParams,
        actionButtonColor: 'primary',
      }
    : {
        header: 'forms:listView.noCreatedForms.header',
        buttonText: 'forms:listView.noCreatedForms.buttonText',
        onActionButtonClick: () => setNewFormWizardOpen(true),
        actionButtonColor: 'green',
      };

  return (
    <BaseNotFound
      sx={theme => ({
        minHeight: 300,
        backgroundColor: theme.white,
        border: `1px solid ${theme.colors.gray[1]}`,
        marginTop: -1,
      })}
      {...props}
    />
  );
};
